<template>
  <div class="waitdevice-bd">
    <div class="waitdevice-wrap">
      <div class="waitdevice-left ubv">
        <div class="search-hd">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item>
              <div class="title">{{ $t('base_waitdevice.dai_fen_pei_she_bei') }}</div>
            </el-form-item>
            <el-form-item style="float: right; margin-right: 0">
              <custom-column ref="column"></custom-column>
            </el-form-item>
            <!-- 搜索栏 -->
            <el-form-item style="float: right;">
              <search-input :placeholder="$t('base_waitdevice.jshModemSNjqmc')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
            </el-form-item>
            <el-form-item style="float: right">
              <switch-button :link="link"></switch-button>
            </el-form-item>
          </el-form>
        </div>
        <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
          <el-form :inline="true" label-position="top">
            <el-form-item :label="$t('base_waitdevice.chan_pin_xing_hao')">
              <custom-select
                url="productCodeSelectList"
                v-model="formSearch.productCode"
                :props="{ label: 'productCode', value: 'productCode' }"
                :placeholder="$t('Common.com_please_select')"
                width="100%"
              ></custom-select>
            </el-form-item>
            <el-form-item :label="$t('base_waitdevice.zu_zhi_ming_cheng')">
              <custom-select
                style="display: inline-block; width: 98px; margin-right: 2px"
                @clear="formSearch.orgName = ''"
                v-model="formSearch.orgType"
                code="bas_org_type"
                :props="{ label: 'name', value: 'value' }"
                :placeholder="$t('base_waitdevice.zu_zhi_lei_xing')"
                width="100%"
              ></custom-select>
              <el-input :disabled="!formSearch.orgType" v-model="formSearch.orgName" style="width:calc(100% - 100px)"></el-input>
            </el-form-item>
            <el-form-item :label="$t('base_waitdevice.xiang_mu_ming_cheng')">
              <el-input v-model="formSearch.locationName" style="width:100%;"></el-input>
            </el-form-item>
            <el-form-item :label="$t('base_waitdevice.xiang_mu_biao_qian')">
              <el-input v-model="formSearch.tagName" style="width:100%;"></el-input>
            </el-form-item>
          </el-form>
        </switch-container>
        <div class="table-bd1">
          <custom-table
            type="checkbox"
            tableCode="wait_device"
            v-model="tableSelect"
            :data="deviceList"
            @column="setColumn"
            @filter="filterChange"
            @sort="sortChange"
            height="100%"
            :clickSelection="true"
          ></custom-table>
        </div>
        <!-- 分页 -->
        <div class="table-page">
          <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
        </div>
      </div>
      <div class="waitdevice-right ub">
        <div class="left-box ub-f1">
          <div class="tit">{{ $t('base_waitdevice.xzbmyg') }}</div>
          <div class="tree-box">
            <div class="tree">
              <el-tree
                ref="tree"
                show-checkbox
                node-key="bizId"
                :data="organTree"
                :props="{ label: 'bizName' }"
                @check-change="checkChange"
                :expand-on-click-node="false"
                :default-expanded-keys="expandedKeys"
                highlight-current
              >
                <span class="tree-item" slot-scope="{ node, data }">
                  <i style="color: #F7B500" v-if="data.bizType === 3" class="icon icon-yonghu1"></i>
                  <i style="color: #00AFFF" v-else class="icon icon-zuzhi1"></i>
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
        <div class="right-box ub-f1">
          <div class="tit">{{ $t('base_waitdevice.yxbmyg') }}</div>
          <div class="tree-box">
            <div class="tree">
              <el-tree
                ref="tree1"
                check-strictly
                node-key="bizId"
                :data="organTree"
                :props="{ label: 'bizName' }"
                :expand-on-click-node="false"
                :default-expanded-keys="expandedKeys"
                :filter-node-method="filterCheckNode"
                highlight-current
              >
                <span class="tree-item" slot-scope="{ node, data }">
                  <i style="color: #F7B500" v-if="data.bizType === 3" class="icon icon-yonghu1"></i>
                  <i style="color: #00AFFF" v-else class="icon icon-zuzhi1"></i>
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
          <div class="btn" :class="{ disabled: disabled }" @click="saveBind">{{ $t('base_waitdevice.que_ren') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  mixins: [resetFormSearchMixins],
  name: 'waitdevice',
  components: {
  },
  data() {
    return {
      // provide: true,
      // translate: { i18n, funcView },
      // tableCode: 'wait_device',
      tableSelect: [],
      selectNodes: [],
      deviceList: [],
      totalRows: 0,
      expandedKeys: [],
      organTree: [],
      treeProps: {
        children: 'children',
        label: 'bizName'
      },
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        /** 高级搜索 */
        productCode: '',
        orgType: '',
        orgName: '',
        locationName: '',
        tagName: '',
      },
      link: null
    };
  },
  computed: {
    disabled: vm => vm.tableSelect.length === 0 || vm.selectNodes.length === 0
  },
  mounted() {
    this.getWaitDevice();
    this.getOrganTree();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

  },

  methods: {
    // 获取未分配设备列表
    getWaitDevice: function () {
      this.$getJSON(apis.DeviceWaitPage, this.formSearch).then((res) => {
        this.deviceList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 获取组织
    getOrganTree: function () {
      this.$getJSON(apis.DepartmentTree, { isShowUsers: 1 }).then((res) => {
        this.expandedKeys = [res.data.bizId];
        this.organTree = [res.data];
        this.$nextTick(() => {
          this.$refs.tree1.filter([]);
        });
      });
    },
    // 选中转换树
    checkChange: function () {
      this.selectNodes = this.$refs.tree.getCheckedNodes(false, true);
      this.$refs.tree1.filter(this.selectNodes);
    },
    // 选中树过滤
    filterCheckNode(nodes, data) {
      return !!nodes.find(t => t.bizId === data.bizId);
    },
    // 保存绑定
    saveBind: function () {
      if (this.tableSelect.length === 0 || this.selectNodes.length === 0) {
        return;
      }
      const bizInfos = this.selectNodes.map(t => ({
        bizId: t.bizType === 3 ? t.userId : t.bizId,
        bizType: t.bizType,
        parentId: t.parentId
      }));
      const deviceIds = this.tableSelect.map(t => t.deviceId);
      this.$postJSON(apis.DeviceBindUser, { bizInfos, deviceIds }).then(() => {
        this.getWaitDevice();
        this.getOrganTree();
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getWaitDevice();
    }
  }
};
</script>

<style lang="scss">
.waitdevice-bd {
  height: calc(100% - 32px);
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 16px;
  .waitdevice-wrap {
    display: flex;
    flex: 1;
    height: 0;
    .waitdevice-left {
      flex: 5;
      padding: 0 16px;
      margin-right: 16px;
      background-color: #ffffff;
      .title {
        color: #495057;
        font-size: 14px;
        font-weight: bold;
      }
      .table-bd1 {
        flex: 1;
        height: 0;
      }
    }
    .waitdevice-right {
      .tit {
        line-height: 60px;
        color: #394668;
        font-weight: bold;
        font-size: 14px;
        padding: 0 16px;
      }
      .left-box {
        width: 282px;
        height: 100%;
        display: flex;
        flex-direction: column;
        margin-right: 16px;
        background-color: #ffffff;
      }
      .right-box {
        width: 282px;
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: #ffffff;
        .btn {
          cursor: pointer;
          margin-left: 16px;
          margin-bottom: 16px;
          width: 250px;
          height: 32px;
          line-height: 30px;
          color: #ffffff;
          font-size: 12px;
          text-align: center;
          border-radius: 2px;
          background: rgba(13, 154, 224, 1);
          border: 1px solid rgba(13, 154, 224, 1);
          &.disabled {
            cursor: not-allowed;
            background-color: #86cdf0;
            border: 1px solid #86cdf0;
          }
        }
      }
      .tree-box {
        flex: 1;
        height: 0;
        padding: 0 16px 16px;
      }
      .tree {
        height: 100%;
        overflow-y: auto;
        .tree-item {
          flex: 1;
          display: flex;
          align-items: center;
          font-size: 12px;
          padding-right: 8px;
          .icon {
            margin-right: 4px;
            font-size: 15px;
          }
          .el-checkbox__label {
            font-size: 12px;
          }
          span {
            color: #6c757d;
          }
        }
      }
    }
  }
}
</style>
